import { Controller } from "@hotwired/stimulus"

// One-click copy for a value (e.g. a payment link). Uses the async Clipboard API
// with a legacy execCommand fallback for older / insecure-context browsers, then
// flashes "Copied!" on the button before restoring its label.
//
// Usage:
//   data-controller="clipboard" data-clipboard-success-value="Copied!"
//   <input data-clipboard-target="source" value="https://…" readonly>
//   <button data-action="clipboard#copy" data-clipboard-target="button">Copy</button>
export default class extends Controller {
  static targets = ["source", "button"]
  static values = { success: { type: String, default: "Copied!" } }

  async copy(event) {
    event.preventDefault()
    const text = this.sourceTarget.value

    try {
      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(text)
      } else {
        this.#legacyCopy()
      }
      this.#flash()
    } catch {
      // Last resort: select the field so the operator can copy manually.
      this.sourceTarget.select()
    }
  }

  #legacyCopy() {
    this.sourceTarget.removeAttribute("readonly")
    this.sourceTarget.select()
    document.execCommand("copy")
    this.sourceTarget.setAttribute("readonly", "readonly")
  }

  #flash() {
    if (!this.hasButtonTarget) return
    const original = this.buttonTarget.textContent
    this.buttonTarget.textContent = this.successValue
    setTimeout(() => { this.buttonTarget.textContent = original }, 1500)
  }
}
